/**
 * Analytics events — pushes conversions into the GTM dataLayer.
 *
 * Forminator announces a successful AJAX submit by triggering the jQuery
 * event `forminator:form:submit:success` on the form (it bubbles to
 * document). jQuery-triggered events are invisible to native listeners,
 * so this must go through jQuery — which Forminator guarantees is present
 * on any page that renders a form.
 */
export function initAnalytics() {
	if ( ! window.jQuery ) {
		return;
	}

	window.jQuery( document ).on( 'forminator:form:submit:success', ( e ) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			event: 'callback_request',
			formId: e.target && e.target.id ? e.target.id : '',
		} );
	} );
}
